/** @jsxImportSource @emotion/react */
import { css, useTheme } from "@emotion/react";
import ToolBar from "../components/MainComponents/ToolBar/ToolBar";
import InformationText from "../components/MainComponents/Analyses/InformationText";
import AnalysesHeader from "components/MainComponents/Analyses/FormComponents/AnalyseHeader";
import FormCard from "components/MainComponents/Analyses/FormComponents/Form";

export default function NewAnalysisPage() {
  const theme = useTheme();

  return (
    <>
      <div>
        <AnalysesHeader
          setNewAnalysis={()=> false}
          showSeeAllLink={true}
          totalAnalyses={0}
        />
        <FormCard />
        <InformationText />
      </div>
    </>
  );
}
